import React from 'react'
import { useAuth } from '../context/AuthContext'
import { useToast } from '../context/ToastContext'

export default function AgreementModal() {
    const { pendingAgreements, dismissAgreement } = useAuth()
    const { addToast } = useToast()
    const [acknowledged, setAcknowledged] = React.useState(false)
    const [loading, setLoading] = React.useState(false)

    // Reset checkbox whenever the shown agreement changes
    React.useEffect(() => { setAcknowledged(false) }, [pendingAgreements[0]?.id])

    if (pendingAgreements.length === 0) return null

    const agreement = pendingAgreements[0]
    const remaining = pendingAgreements.length

    const label = agreement.subtype
        ? `${agreement.type} — ${agreement.subtype}`
        : agreement.type

    async function handleSubmit(e) {
        e.preventDefault()
        if (!acknowledged) return
        setLoading(true)
        try {
            await dismissAgreement(agreement.id)
        } catch (err) {
            addToast(err.message, 'error')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 flex flex-col max-h-[90vh]">
                <div className="px-6 pt-5 pb-3 border-b border-gray-200">
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-400 m-0">
                        Agreement {remaining > 1 ? `(${remaining} remaining)` : ''}
                    </p>
                    <h2 className="text-lg font-bold text-bankroll-text mt-1 mb-0 capitalize">{label}</h2>
                    <p className="text-xs text-gray-400 m-0 mt-0.5">
                        Effective {new Date(agreement.effective_date + 'T00:00:00').toLocaleDateString()}
                    </p>
                </div>

                <div className="px-6 py-4 overflow-y-auto flex-1 text-sm text-bankroll-text font-karla whitespace-pre-wrap leading-relaxed">
                    {agreement.content}
                </div>

                <form className="px-6 py-4 border-t border-gray-200 flex flex-col gap-3" onSubmit={handleSubmit}>
                    <label className="flex items-start gap-2.5 cursor-pointer text-sm text-bankroll-text font-karla">
                        <input
                            type="checkbox"
                            className="mt-0.5 accent-bankroll-primary"
                            checked={acknowledged}
                            onChange={e => setAcknowledged(e.target.checked)}
                        />
                        I have read and agree to this {agreement.type} agreement.
                    </label>

                    <button
                        type="submit"
                        disabled={!acknowledged || loading}
                        className="py-2.5 bg-bankroll-primary text-white font-karla font-semibold rounded-md hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Saving…' : remaining > 1 ? 'Acknowledge & Continue' : 'Acknowledge'}
                    </button>
                </form>
            </div>
        </div>
    )
}
